import { toast } from "react-toastify";

export function FlashMessage(type, text, title) {
	const defaultValues = {
		closeButton: true,
		showAnimation: 'animated slideInDown',
		hideAnimation: 'animated slideOutUp',
		showDuration: 50,
		hideDuration: 50,
		timeOut: 4000
	}
	switch (type) {
		case 'success':
			toast.success(text, title, defaultValues)
			break;
		case 'error':
			toast.error(text, title, defaultValues)
			break;
		case 'danger':
			toast.error(text, title, defaultValues)
			break;
		default:
			break;
	}
}
